<template>
  <button
    class="c-hands-free-headline u-flex u-flex-align-center"
    @click="togglePopup"
  >
    <Icon
      class="u-mr--xs"
      :icon="micIcon"
      :size="24"
    />
    <span class="u-text-uppercase u-font-bold u-font-size-large">{{ title }}</span>
    <span class="headline-opener">
      <span v-if="isLoading">
        <span class="spinner">
          <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="8"
              cy="8"
              r="7"
              stroke-width="2"
            />
          </svg>
        </span>
      </span>
      <Icon
        v-else
        :icon="icon"
        :size="24"
      />
    </span>
  </button>
</template>

<script>

import Icon from '@/components/Icon.vue'
import micIcon from '@/assets/img/icons/mic.svg'
import chevronDown from '@/assets/img/icons/chevron--down.svg'
import close from '@/assets/img/icons/close.svg'
import { computed } from 'vue'

export default {
  components: {
    Icon
  },
  props: {
    title: {
      type: String,
      required: true
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    isCloseState: {
      type: Boolean,
      default: false
    }
  },
  emits: ['togglePopup'],
  setup(_, { emit }) {
    const togglePopup = () => {
      emit('togglePopup')
    }

    const icon = computed(() => (_.isCloseState ? close : chevronDown))

    return {
      togglePopup,
      micIcon,
      chevronDown,
      close,
      icon
    }
  }
}
</script>
